var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiKeys(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.897,
    height: 27.882,
    viewBox: "0 0 27.897 27.882",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "key-outline",
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5619",
    "data-name": "Pfad 5619",
    d: "M15.089,11.919a7.031,7.031,0,0,0,.255,2.328C12.661,17.4,5.577,25.72,4.917,26.355a1.256,1.256,0,0,0-.417.934,2.077,2.077,0,0,0,.6,1.326c.411.43,2.166,2.054,2.49,1.743.959-.934,1.152-1.183,1.544-1.569.591-.579-.062-1.762.143-2.241a.908.908,0,0,1,.778-.647,11.634,11.634,0,0,1,1.475.187,1.557,1.557,0,0,0,1.183-.573,1.31,1.31,0,0,0,.542-.971c.012-.56-.8-1.3-.193-1.892s1.475.386,2.117.311a2.351,2.351,0,0,0,1.5-1.345c.081-.38-.728-1.357-.6-1.911a1.3,1.3,0,0,1,.71-.685c.286-.062,1.556.43,1.843.367a4.377,4.377,0,0,0,1.083-.647,7.011,7.011,0,0,0,2.969.585,7.575,7.575,0,0,0,7.719-7.42A7.563,7.563,0,0,0,22.678,4.5,7.459,7.459,0,0,0,15.089,11.919Zm11.324-1.442a1.992,1.992,0,1,1-1.992-1.992A1.992,1.992,0,0,1,26.413,10.476Z",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeys);
export default __webpack_public_path__ + "static/media/api-keys.e1a6090c93a9336639066b545d280b59.svg";
export { ForwardRef as ReactComponent };